
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Définition : la communication interne, c’est quoi ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez ce qu'est la communication interne et apprenez à l'optimiser pour renforcer l'engagement de vos équipes et l'efficacité de votre entreprise.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Définition : la communication interne, c’est quoi ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Qu’est-ce que la communication interne ? Comment optimiser la vôtre ? Cet article vous explique tout !",
        },
      ],
    };
  },
};
